
export function PageNotFound(): JSX.Element {
    return <div>Page Not Found</div>;
}
